import { render, staticRenderFns } from "./tabRanking.vue?vue&type=template&id=6b7f6018&scoped=true"
import script from "./tabRanking.vue?vue&type=script&lang=js"
export * from "./tabRanking.vue?vue&type=script&lang=js"
import style0 from "./tabRanking.vue?vue&type=style&index=0&id=6b7f6018&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7f6018",
  null
  
)

export default component.exports